import { render } from "./fullscreen.vue?vue&type=template&id=6f4dcff4"
import script from "./fullscreen.vue?vue&type=script&lang=js"
export * from "./fullscreen.vue?vue&type=script&lang=js"

import "./fullscreen.vue?vue&type=style&index=0&id=6f4dcff4&lang=less"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__